module.exports = __webpack_public_path__ + "static/media/sunspaceBrands.38060340.png";